<template>
  <div class="index">
    <el-container>
      <el-header style="height: none">
        <div class="logo" v-show='oLogo!=showNav' v-for="(item,index) in navMenu.slice(0,1)" :key="index"  @click="setTag(item)">
          <img src="../../assets/images/logo.png" alt="" />
        </div>
        <div class="sort">
          <img
            src="../../assets/images/sort.png"
            alt=""
            @click="showNav = true"
          />
        </div>
        <div class="header">
          <div class="headerNav" v-show="showNav">
            <div class="remove" >
              <img
                src="../../assets/images/remove.png"
                alt=""
                @click="showNav = false"
              />
            </div>
            <el-row class="tac">
              <el-col :span="12">
                <el-menu
                  :default-active="$route.path"
                  router
                  text-color="#fff"
                  @select="showNav = false"
                >
                  <template v-for="item in navMenu">
                    <el-menu-item
                      v-if="!item.children"
                      :key="item.id + 'd'"
                      :index="item.url"
                      >{{ item.title }}</el-menu-item
                    >
                    <el-submenu
                      v-if="item.children"
                      :key="item.id"
                      :index="item.url"
                      class="subNav"
                    >
                      <template slot="title">
                        <span class="navTitle">{{ item.title }}</span>
                      </template>
                      <el-menu-item
                        v-for="(subItem, subIndex) in item.children"
                        :key="subIndex"
                        :index="subItem.url"
                        >{{ subItem.title }}</el-menu-item
                      >
                    </el-submenu>
                  </template>
                </el-menu>
              </el-col>
            </el-row>
            <div class="bottom">
              <div><img src="../../assets/images/bot.png" alt="" /></div>
              <p>科技·匠筑·健康·生活</p>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <div class="main-container" ref="main">
          <el-main>
            <router-view></router-view>
          </el-main>
          <el-footer>
            <el-menu
              default-active="2"
              class="el-menu-footer"
              background-color="#222"
              text-color="#fff"
              active-text-color="#ffd04b"
              router
            >
              <template v-for="item in navMenu">
                <el-menu-item
                  v-if="!item.children"
                  v-show="item.id != 0"
                  :key="item.id + 'd'"
                  :index="item.url"
                  >{{ item.title }}</el-menu-item
                >
                <el-submenu
                  v-if="item.children"
                  :key="item.id"
                  :index="item.url"
                >
                  <template slot="title">
                    <span class="navTitle">{{ item.title }}</span>
                  </template>
                  <el-menu-item
                    v-for="(subItem, subIndex) in item.children"
                    :key="subIndex"
                    :index="subItem.url"
                    >{{ subItem.title }}</el-menu-item
                  >
                </el-submenu>
              </template>
            </el-menu>
            <div class="home-footer">
              <p>保定市爱城置业有限公司</p>
              <p>地址：北京市丰台区国投财富广场2号楼18层</p>
              <p>联系电话：010-6336 6673</p>
              <p>
                <span class="records"><a href="https://beian.miit.gov.cn"> 冀ICP备20017716号 </a></span> 
                <!-- <span>｜ 京公网安备11011011011</span> -->
              </p>
            </div>
          </el-footer>
        </div>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
      showNav: false,
      oLogo:true,
      navMenu: [
        {
          id: 0,
          title: "首页",
          url: "/",
        },
        {
          id: 1,
          title: "爱情地产",
          url: "/company",
          children: [
            {
              title: "· 集团简介",
              url: "/introduct",
            },
            {
              title: "· 品牌理念",
              url: "/brand",
            },
            {
              title: "· 战略布局",
              url: "/strategic",
            },
            {
              title: "· 品牌荣誉",
              url: "/honor",
            },
            {
              title: "· 发展历程",
              url: "/develop",
            },
          ],
        },
        {
          id: 2,
          title: "产品创新",
          url: "/product",
        },
        {
          id: 3,
          title: "业务板块",
          url: "/business",
          children: [
            {
              title: "· 地产开发",
              url: "/house",
            },
            {
              title: "· 商业运营",
              url: "/business",
            },
            {
              title: "· 物业服务",
              url: "/propertyService",
            },
          ],
        },
        {
          id: 4,
          title: "新闻中心",
          url: "/news",
          children: [
            {
              title: "· 集团要闻",
              url: "/groupNews",
            },
            {
              title: "· 媒体报道",
              url: "/media",
            },
            {
              title: "· 品牌影像",
              url: "/brandImage",
            },
            // {
            //   title: "· 品牌画册",
            //   url: "/picture",
            // },
            {
              title: "· 社交媒体",
              url: "/social",
            },
          ],
        },
        {
          id: 5,
          title: "加入我们",
          url: "/invite",
          children: [
            {
              title: "· 员工风采",
              url: "/staffStyle",
            },
            {
              title: "· 我要应聘",
              url: "/application",
            },
          ],
        },
        {
          id: 6,
          title: "联系我们",
          url: "/relation",
        },
      ],
    };
  },
  methods: {
    setTag(item) {
      this.$router.push({
        path: item.url,
      });
    },
  },
  watch: {
    "$route.path"() {
      this.$refs.main.scrollTop = 0;
    },
  },
};
</script>
<style scoped lang="less">
img {
  width: 100%;
}
.el-header {
  padding: 13px 15px 12px;
  border-bottom: 1px solid #efefef;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .logo{
    float: left;
  }
  .sort{
    float: right;
  }
  .header {
    width: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10000;
  }
  .headerNav {
    width: 239px;
    height: 100vh;
    overflow: scroll;
    background: rgba(234, 94, 19, 0.94);
    padding: 52px 0 0 0;
    float: right;

    .remove {
      width: 22px;
      height: 22px;
      margin-left: -37px;
      margin-top: -35px;
      display: flex;
      // border: 1px dotted #333;
      position: absolute;
      img {
        width: 100%;
      }
    }
    .bottom {
      text-align: left;
      padding: 62px 54px 44px 29px;
      font-size: 12px;
      line-height: 17px;
      color: #fff;
      left: 0;
      bottom: 0;
      div {
        width: 152px;
      }
      p {
        margin-top: 10px;
        opacity: 0.69;
        margin-bottom: 0;
        span {
          font-size: 16px;
          margin-top: 3px;
        }
      }
    }
    .el-col-12 {
      width: 100%;
      // .navTitle{
      //   margin-left: -15px;
      // }
    }
    /deep/.el-menu {
      border: none;
      background: none;
      .is-opened {
        .el-submenu__title {
          border: none;
        }
      }
      .subNav {
        .el-menu--inline {
          background: #bd4200 !important;
        }
        .el-menu-item {
          border: none;
          padding-left: 20px !important;
        }
      }
      .el-menu--inline {
        background: none;
      }
      .el-menu-item.is-active {
        color: rgba(255, 255, 255, 0.59);
      }
    }
    .el-menu-item {
      border-bottom: 0.5px solid rgba(239, 239, 239, 0.59);
      margin: 0 20px;
      padding: 0 !important;
    }
    .el-submenu {
      /deep/.el-submenu__title {
        border-bottom: 0.5px solid rgba(239, 239, 239, 0.59);
        margin: 0 20px 0 20px;
        padding: 0 !important;
      }
      /deep/.el-submenu__title:hover {
        background: none;
      }
    }
  }
}
.logo {
  width: 82px;
  height: 30px;
  display: flex;
}
.sort {
  width: 22px;
  height: 22px;
  margin: 4px 0;
  display: flex;
}
.home-footer {
  background: #222;
  font-size: 12px;
  color: #666;
}
.el-container .el-main {
  padding: 0;
  overflow: initial;
}
.el-footer {
  padding: 0;
}

.el-menu-footer {
  .el-menu-item{
     border-bottom: 1px solid #333333;
  }
  .el-submenu {
    border-bottom: 1px solid #333333;
    .el-menu--inline{
      .el-menu-item{
        border: none;
      }
    }
    .el-submenu__title {
      background: #222222;
      line-height: 0;
      height: 0;
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
/deep/.el-submenu > div {
  padding-left: 15px;
}
// .navTitle {
//   margin-left: -5px;
// }
.home-footer {
  padding: 21px 0 31px 14px;
  font-size: 12px;
  line-height: 17px;
}
.home-footer p {
  margin-bottom: 10px;
  .records{
    a{
      color: #666;
      text-decoration: none;
    }
  }
}
.home-footer p:last-child {
  margin-top: 10px;
}
.main-container {
  height: calc(100vh - 56px);
  width: 100%;
  overflow: auto;
  .el-menu-item {
    .el-submenu__title {
      border-bottom: 0.5px solid rgba(239, 239, 239, 0.59);
    }
  }
}
/deep/.el-submenu__icon-arrow {
  color: #fff;
}
.el-menu-footer{
  border: none;
}
</style>
